import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const postReadOpeningStory = async () => {
  const res = await axiosInstance.post(API_ROUTES.Tracking.ActionAccessLine, { action_name: 'read_open_story_at' })
  return res.data
}

const postStartOpeningStory = async () => {
  const res = await axiosInstance.post(API_ROUTES.Tracking.ActionAccessLine, { action_name: 'start_opening_story_at' })
  return res.data
}

const postPlayChatNow = async () => {
  const res = await axiosInstance.post(API_ROUTES.Tracking.ActionAccessLine, { action_name: 'play_chat_now_at' })
  return res.data
}

export { postReadOpeningStory, postStartOpeningStory, postPlayChatNow }
